import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Store } from 'redux';

function loadComponents(): Promise<{[key: string]: any}> {
  return new Promise((resolve, reject) => {
    require.ensure([
      './components/open_button/open_button_container',
      './action_creators/object_error_form_actions',
    ], () => {
      resolve({
        OpenButtonContainer: require('./components/open_button/open_button_container').default,
        setFormData: require('./action_creators/object_error_form_actions').setFormData,
      });
    });
  });
}

export default function initObjectPopupError<T>( store: Store<T>) {
  return (element: Element, props: { bcId: number }) =>
    loadComponents()
      .then(({ OpenButtonContainer, setFormData }) => {
        store.dispatch(setFormData({businessShoppingCenterId: props.bcId}));
        render(
          <Provider store={store}>
            <OpenButtonContainer />
          </Provider>,
          element
        );
      });
}



// WEBPACK FOOTER //
// ./src/bundles/business_shopping_center_detail/components/object_error_form/index.tsx